function Leadership() {
  return (
    <div className="section">
      <div className="container">
        <h1 className="title">Leadership Development</h1>
        <p className="text">
          Building strong leaders through coaching and mindset development.
        </p>
      </div>
    </div>
  );
}

export default Leadership;